export default __webpack_public_path__ + "static/media/authorProfile.a4407361.png";